import styled from 'styled-components';

export const StyledMusicPlayer = styled.div`
  width: 100%;
  height: 100px;

  .fr-music-player {
    width: 100%;
    height: 100%;
    /* background-color: darkgray; */
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(148px);
    position: relative;

    &__controls {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(100% - 48px);
      height: calc(100% - 32px);
      padding: 16px 24px;
      gap: 60px;

      &__track-info {
        gap: 16px;

        &__title {
          flex-direction: column;
          gap: 4px;
          align-items: flex-start;
          justify-content: center;
          width: 300px;

          p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
          }
        }

        &__image {
          width: 68px;
          border-radius: 16px;

          img {
            border-radius: 16px;
          }
        }
      }

      &__player {
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        color: ${({ theme }) => theme.colors.white};

        &__play {
          height: 44px;

          &__play-button {
            cursor: pointer;
          }
          &__next-button {
            margin-left: 20px;
            cursor: pointer;
          }
          &__tracklist-button {
            margin-right: 20px;
            cursor: pointer;
          }
        }

        &__progress {
          width: 100%;
          align-items: center;
          justify-content: center;
          gap: 12px;
        }
      }

      &__volume {
        width: 300px;
        align-items: center;
        justify-content: center;
        gap: 10px;

        &__action {
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          cursor: pointer;
          color: ${({ theme }) => theme.colors.white};
        }
      }
    }
  }
`;
